import React, { createContext, useContext, useState, useEffect } from 'react';

const FrontDeskAuthContext = createContext(null);

function parseJwt(token) {
  try { return JSON.parse(atob(token.split('.')[1])); }
  catch { return null; }
}

export function FrontDeskAuthProvider({ children }) {
  const [fdUser,    setFdUser]    = useState(null);
  const [fdLoading, setFdLoading] = useState(true);
  const [isInternal, setIsInternal] = useState(false);

  useEffect(() => {
    async function init() {
      // 1. Recoger token de URL tras callback Google
      const params = new URLSearchParams(window.location.search);
      const tokenFromUrl = params.get('fd_token');
      if (tokenFromUrl) {
        localStorage.setItem('fd_token', tokenFromUrl);
        window.history.replaceState({}, '', window.location.pathname);
      }
      // Limpiar error de URL
      if (params.get('auth_error')) {
        window.history.replaceState({}, '', window.location.pathname);
      }

      // 2. Comprobar si está en red interna
      try {
        const res  = await fetch('/api/auth/network-check');
        const data = await res.json();
        if (data.internal) {
          setIsInternal(true);
          setFdLoading(false);
          return; // red interna → no necesita login
        }
      } catch { /* si falla el check, requerir login */ }

      // 3. Red externa → comprobar token guardado
      const stored = localStorage.getItem('fd_token');
      if (stored) {
        const payload = parseJwt(stored);
        if (payload && payload.exp * 1000 > Date.now() && payload.type === 'frontdesk') {
          setFdUser({ email: payload.email, name: payload.name, picture: payload.picture });
        } else {
          localStorage.removeItem('fd_token');
        }
      }

      setFdLoading(false);
    }

    init();
  }, []);

  function fdLogout() {
    localStorage.removeItem('fd_token');
    setFdUser(null);
  }

  // En red interna: fdUser es null pero isInternal es true → el FrontDesk permite acceso
  const canAccess = isInternal || !!fdUser;

  return (
    <FrontDeskAuthContext.Provider value={{ fdUser, fdLoading, isInternal, canAccess, fdLogout }}>
      {children}
    </FrontDeskAuthContext.Provider>
  );
}

export function useFrontDeskAuth() { return useContext(FrontDeskAuthContext); }
